module.exports = __webpack_public_path__ + "assets/img/light-homelogo-en.44444256.png";